import { render, staticRenderFns } from "./FamilyRewardsDrawer.vue?vue&type=template&id=644ac1e6"
import script from "./FamilyRewardsDrawer.vue?vue&type=script&lang=js"
export * from "./FamilyRewardsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports